<script>
import {assignOnObject, byString, FormFieldMixin} from "laravel-vue-forms";

export default {

    inject: {
        mpid: {
            default() {
                return this.$store.state.mp_layout.assessmentMPID
            }
        }
    },

    mixins: [
        FormFieldMixin
    ],

    data() {
        return {
            overrideChecked: 0,
            watcher: null
        }
    },

    created() {

        if (!this.form.formConfig.fields.find(ff => {
            return ff.value_field === this.fieldConfig.field_extra.overrideField
        })) {
            console.error('Unable to find companion field for overriding attribute saving');
        }else {
            this.overrideChecked = Number(byString(this.form.data, this.fieldConfig.field_extra.overrideField))
        }

        this.setupWatcher();
    },

    computed: {
        overrideFieldDisabled() {
            if (this.fieldConfig.disabled === 1 || this.fieldConfig.disabled === true) {
                return true;
            }

            if (byString(this.form.data, this.fieldConfig.field_extra.overrideField) == 1) {
                return false
            }

            return true;
        }
    },

    watch: {
        overrideChecked(newOverrideValue) {
            if (!this.form.formConfig.fields.find(ff => {
                return ff.value_field === this.fieldConfig.field_extra.overrideField
            })) {
                console.error('Unable to find companion field for overriding attribute saving');
                return;
            }

            this.overrideChecked = newOverrideValue;
            assignOnObject(this.form.data, this.fieldConfig.field_extra.overrideField, newOverrideValue);

            if(
                this.fieldConfig.field_extra.technologyToWatch &&
                newOverrideValue === false &&
                Array.isArray(this.form.formFieldOptions[this.fieldConfig.field_extra.technologyToWatch]) &&
                this.form.formFieldOptions[this.fieldConfig.field_extra.technologyToWatch].length > 0
            ) {
                const selectedTechnology = this.form.formFieldOptions[this.fieldConfig.field_extra.technologyToWatch].find(tech => {
                    return tech.id === byString(this.form.data, this.fieldConfig.field_extra.technologyToWatch);
                });

                if(selectedTechnology) {
                    this.updateValue(selectedTechnology.wattage);
                }
            }

        }
    },

    methods: {
        updateValue(value) {
            if(this.watcher) {
                this.watcher();
            }
            this.form.errors.clear(this.fieldConfig.value_field);
            this.$emit("input", value);
            this.$nextTick(() => {
                this.setupWatcher();
            })
        },
        setupWatcher() {
            if(this.watcher) {
                this.watcher();
            }

            this.watcher = this.$watch('value', newValue => {
                this.overrideChecked = false;
            });
        }
    }

}
</script>
<template>
    <div
        class="form-group"
        :id="fieldName + '-wattage-override-field'"
        :class="{ 'has-error': form.errors.has(fieldConfig.value_field) }"
    >
        <label class="form-control-label">
            <span v-html="fieldConfig.label"></span>
            <span class="required" v-if="fieldConfig.field_extra.required">
        &nbsp;&nbsp;(*)
      </span>
            <span
                v-if="withHelpIcon"
                :class="fieldConfig.field_extra.withIcon"
                :title="fieldConfig.field_extra.helpText"
            ></span>
        </label>
        <div class="flex items-center mr-4" style="width:95%;">
            <div class="form-check w-1/4">
                <input
                    class="form-check-input"
                    type="checkbox"
                    :id="fieldConfig.fieldName + '-override-checkbox'"
                    v-model="overrideChecked"
                    :true-value="1"
                    :false-value="0"
                    :disabled="fieldConfig.disabled === 1 || fieldConfig.disabled === true"
                />
                <label class="form-check-label" :for="fieldConfig.fieldName + '-override-checkbox'">
                    <span>Override wattage?</span>
                </label>
            </div>
            <input
                input="text"
                class="form-control w-3/4"
                :name="fieldConfig.fieldName"
                ref="formText"
                :value="value"
                @input="updateValue($event.target.value)"
                :disabled="overrideFieldDisabled"
            />
            <span class="errors" v-if="form.errors.has(this.fieldConfig.value_field)">
        {{ form.errors.get(this.fieldConfig.value_field, true) }}
      </span>
        </div>
        <div v-if="hasHelpText">
            <span v-html="fieldConfig.field_extra.helpText"></span>
        </div>
    </div>
</template>
